import React from 'react'

const OptionButtons = ({productOptions, selectedOptionInModel, selection, selectedOption, skus}) => {
  //new component - Display of product variants as buttons/ tiles without the overhead of multiple clicks associated with dropdowns
  return (
    <div className="optionGroup d-flex flex-column">
      {productOptions?.map(({ optionGroupName, options, optionGroupID, optionGroupCode }) => {
        const selectedOptionCode = selection[optionGroupCode] || 'select'

        return (
          <div className="form-group pe-4 my-4" key={optionGroupID}>
            <div className="d-flex justify-content-between align-items-center pb-1">
              <label className="optionGroupName h6" htmlFor={optionGroupID}>
                {optionGroupName}
              </label>
            </div>
            <div className="d-flex options-div flex-wrap" required value={selectedOptionCode} id={optionGroupID}>
              {/* Only for available variants. providing checked for input for preselecting the value */}
              {options?.map(option => {
                return (
                  <button
                    key={option.optionCode}
                    onClick={e => {
                      if (selectedOptionInModel) {
                        selectedOptionInModel(optionGroupCode, option.optionCode)
                      } else {
                        selectedOption(skus, optionGroupCode, option.optionCode, selection)
                      }
                    }}
                    className={` mx-2 p-1 my-2 btn skuOption ${option.active ? 'active' : 'nonactive'} ${option.available ? 'available' : 'nonavailable'}`}
                  >
                    {option.optionName}
                  </button>
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export { OptionButtons }